var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkerArrival(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_1",
    d: "m23.49367,0.03503c-9.27001,0 -16.7848,7.516 -16.7848,16.7848c0,9.27001 16.7848,31.17178 16.7848,31.17178s16.7848,-21.90177 16.7848,-31.17178c0,-9.26881 -7.5148,-16.7848 -16.7848,-16.7848z",
    fill: "#008942"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_4",
    fill: "#007f3f",
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    d: "m22.38669,3.75784c-0.72958,0.00744 -1.3514,0.60413 -1.3514,1.373l0,8.14679l-6.04168,-1.59143l-0.84492,-2.27554c-0.10446,-0.27898 -0.34242,-0.48811 -0.63369,-0.55448c-0.55304,-0.12658 -1.08256,0.29511 -1.08256,0.86413l0,3.20927c0,1.11468 0.75125,2.09122 1.82906,2.37634l18.01703,4.7767l0,-0.00481a1.84347,1.84347 0 0 0 0.43206,0.05281a1.84347,1.84347 0 0 0 1.84347,-1.84347a1.84347,1.84347 0 0 0 -1.49542,-1.80987l-6.13769,-1.64183l-3.20927,-10.11988c-0.14748,-0.46455 -0.53012,-0.81721 -1.00573,-0.92413c-0.10708,-0.02412 -0.21502,-0.03467 -0.31925,-0.03361l-0.00001,0.00001zm-8.72527,20.05972c-0.6784,0 -1.22898,0.55058 -1.22898,1.22898c0,0.6784 0.55058,1.22898 1.22898,1.22898l19.66366,0c0.6784,0 1.22898,-0.55058 1.22898,-1.22898c0,-0.6784 -0.55058,-1.22898 -1.22898,-1.22898l-19.66366,0z",
    fill: "#ffffff",
    stroke: "null"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerArrival);
export default __webpack_public_path__ + "static/media/marker-arrival.995b2d515677f271a61211461e7d4efa.svg";
export { ForwardRef as ReactComponent };